import { instance as axios } from "@/hooks/api";
import { TourType } from "@/types";

import { normalizeTour } from "./normalize-tour";

export async function fetchTourWithoutAuth(
  tourToken: string
): Promise<TourType | null> {
  const tour = await axios
    .get(`/tour/${tourToken}/public`)
    .then((response) => response.data)
    .then(({ tour, config }) => {
      return normalizeTour(tour, config);
    })
    .catch((_e: any) => {
      // Tour could not be retrieved publicly, which either means it doesn't exist,
      // or that the tour has already been associated with a prospect.
      // Return `null` instead of redirecting so that we can prompt the user to authenticate.
      return null;
    });

  return tour;
}
